import type { ResourceSection } from '../../../mocks/localResources';
import ResourceCard from './ResourceCard';

interface ResourceCategorySectionProps {
  section: ResourceSection;
}

export default function ResourceCategorySection({ section }: ResourceCategorySectionProps) {
  return (
    <section id={section.id} className="scroll-mt-28">
      {/* Section Header */}
      <div className="flex items-center gap-3 mb-8">
        <div className={`w-10 h-10 flex items-center justify-center ${section.iconBg} rounded-xl shrink-0`}>
          <i className={`${section.icon} ${section.color} text-lg`}></i>
        </div>
        <h2 className="text-xl font-extrabold text-gray-900 leading-tight">{section.title}</h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {section.resources.map((resource) => (
          <ResourceCard key={resource.id} resource={resource} section={section} />
        ))}
      </div>
    </section>
  );
}
